<!-- 加载中状态 -->
<template>
    <!-- 显隐 -->
    <van-overlay
      z-index="9999"
      :show="showDialog"
      @click="isClickClose ? (showDialog = false) : ''"
    >
      <div class="wrapper">
        <van-loading
          size="50px"
          text-size="16px"
          color="#886DF3"
          text-color="#666"
          class="block"
          vertical
          >{{ text }}</van-loading
        >
      </div>
    </van-overlay>
  </template>
      <script>
  export default {
    name: "CustomDialog",
    components: {},
    model: {
      prop: "showDialog",
      event: "change",
    },
    props: {
      // 弹框的显示隐藏
      showDialog: {
        type: Boolean,
        default: false,
      },
      // 是否点击遮罩隐藏弹窗
      isClickClose: {
        type: Boolean,
        default: false,
      },
      // 加载文字
      text: {
        type: String,
        default: "标题",
      },
    },
    methods: {},
  };
  </script>
      <style lang="less" scoped>
  .wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
  }
  
  .block {
    width: 187px;
    padding: 30px 0;
    background-color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 10px;
  }
  </style>
      